import React from 'react';
import './HeroSection.css';
import useScrollAnimation from '../hooks/useScrollAnimation';
import LungScanner from './LungScanner';

function HeroSection({ onGetStarted }) {
  const [contentRef, contentVisible] = useScrollAnimation({ threshold: 0.1 });
  const [cardsRef, cardsVisible] = useScrollAnimation({ threshold: 0.1 });

  return (
    <section className="hero">
      <div className="hero-background">
        <div className="hero-gradient"></div>
      </div>
      
      <div className="hero-container">
        <div 
          className={`hero-content scroll-animate fade-left ${contentVisible ? 'visible' : ''}`}
          ref={contentRef}
        >
          <div className="hero-badge">
            <span className="badge-dot"></span>
            AI-Powered Diagnostic Tool
          </div>
          
          <h1 className="hero-title">
            Detect Pneumonia Instantly,<br />
            <span>Anywhere.</span>
          </h1>
          
          <p className="hero-description">
            Upload chest X-ray images and get instant AI-powered analysis. 
            Our deep learning model provides accurate pneumonia detection 
            to assist healthcare professionals in diagnosis.
          </p>
          
          <div className="hero-buttons">
            <button className="btn-primary" onClick={onGetStarted}>
              Get Started
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
            <button className="btn-secondary">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
                <polygon points="10,8 16,12 10,16" fill="currentColor"/>
              </svg>
              Watch Demo
            </button>
          </div>
          
          <div className="hero-stats">
            <div className="stat">
              <div className="stat-value">95%+</div>
              <div className="stat-label">Accuracy Rate</div>
            </div>
            <div className="stat-divider"></div>
            <div className="stat">
              <div className="stat-value">2-3s</div>
              <div className="stat-label">Analysis Time</div>
            </div>
            <div className="stat-divider"></div>
            <div className="stat">
              <div className="stat-value">24/7</div>
              <div className="stat-label">Available</div>
            </div>
          </div>
        </div>
        
        <div 
          className={`hero-visual scroll-animate fade-right delay-200 ${cardsVisible ? 'visible' : ''}`}
          ref={cardsRef}
        >
          <div className="visual-container">
            {/* Lung Scanner Animation */}
            <LungScanner />
            
            {/* Floating Cards */}
            <div className="floating-card card-result">
              <div className="result-icon normal">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div className="result-text">
                <span className="result-label">Result</span>
                <span className="result-value normal">Normal</span>
              </div>
            </div>
            
            <div className="floating-card card-accuracy">
              <div className="accuracy-circle">
                <svg viewBox="0 0 36 36">
                  <path
                    d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                    fill="none"
                    stroke="#e5e7eb"
                    strokeWidth="3"
                  />
                  <path
                    d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                    fill="none"
                    stroke="#8b5cf6"
                    strokeWidth="3"
                    strokeDasharray="95, 100"
                    strokeLinecap="round"
                  />
                </svg>
                <span>95%</span>
              </div>
              <span className="accuracy-label">Confidence</span>
            </div>
            
            <div className="floating-card card-ai">
              <div className="ai-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <span>Deep Learning</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
